import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  pageData: {},
  pageFlag: 'create'
}

export const socialSlice = createSlice({
  name: 'social',
  initialState,
  reducers: {
    // 自动生成 action creator 和 reducer
    setSocialDataAction: (state, action) => {
      state.pageData = action.payload
    },
    setSocialPageFlagAction: (state, action) => {
      state.pageFlag = action.payload
    },
  }
})

// 自动生成的 action creators
export const { setSocialDataAction, setSocialPageFlagAction } = socialSlice.actions

// Selectors
export const selectSocialData = (state) => state.social.pageData
export const selectSocialPageFlag = (state) => state.social.pageFlag

// Reducer
export default socialSlice.reducer